import React, { useState, useEffect, useRef, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Carousel } from "primereact/carousel";
import { Checkbox } from "primereact/checkbox";
import ModalEtiquetaQR from "./Reporte/ModalEtiquetaQR";

// ------------------ COMPONENTES DE BASE--------------------------------
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import Card from "../../../../Base/Components/Card/Card";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import {
  getListadoImagenes,
  mostrarImagenesProductos,
} from "../../../../Base/API/IT/Imagenes/ImagenesRequest";
import { toastShow } from "../../../../Base/Services/ToastService";

// ------------------- CONSULTAS A LA API--------------------------------
import { obtenerProductos } from "../../../../API/Global/Productos/ProductosRequests";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import CrudProductoModal from "./ModalProductos/CrudProductoModel";

export const ProductosScreen = ({ IdType }) => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [productos, setProductos] = useState("");
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState([]);
  const [selectedImg, setSelectedImg] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const [showDialogCodigo, setShowDialogCodigo] = useState(false);
  const [imagenes, setImagenes] = useState([]);
  const [showModalImagenes, setShowModalImagenes] = useState(false);
  const [showEtiqueta, setShowEtiqueta] = useState(false);
  const [etiquetaQR, setEtiquetaQR] = useState(true);

  const getInfo = async () => {
    setLoading(true);

    const productosTempo = await obtenerProductos();
    let r = productosTempo;
    if (IdType === 34) {
      r = productosTempo.filter((i) => i.IdCategoria === 1);
    } else {
      r = productosTempo.filter((i) => i.IdCategoria !== 1);
    }
    setProductos(r);
    setLoading(false);
    setSelected([]);
  };

  const cerrarModal = () => {
    setShowModalImagenes(false);
  };

  const verImagen = async (rowData) => {
    let variable = await getImagenes(rowData);
    setImagenes(variable);
    if (variable) {
      setShowModalImagenes(true);
      setSelectedImg(rowData);
    } else {
      toastShow(toast, "warn", "Advertencia", "El Producto no tiene imágenes.");
    }
  };

  const colums = [
    {
      field: "IdProduct",
      header: "ID",
      headerEn: "ID",
      className: "XXsmall",
      frozen: true,
      hidden: userAuth.IdRol === 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected([data]);
      },
    },
    {
      field: "CodigoProducto",
      header: "Código",
      headerEn: "Code",
      className: "Xsmall",
      frozen: true,
      Sumary: "count",
      Format: "Modal",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected([data]);
      },
    },
    {
      field: "NombreProducto",
      header: "Nombre Producto",
      headerEn: "Product Name",
      className: "XXlarge",
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected([data]);
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "Xsmall",
      frozen: true,
      Format: "Estado",
      filter: true,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
    },
    {
      field: "DescripcionProducto",
      header: "Descripción",
      headerEn: "Description",
      className: "XXXXlarge",
    },
    {
      field: "NoParte",
      header: "Numero de Parte",
      headerEn: "NoPart",
      className: "small",
    },
    {
      field: "Medida",
      header: "Medida",
      headerEn: "Measure",
      className: "small",
    },   
    {
      field: "Currency",
      header: "Moneda",
      headerEn: "Currency",
      className: "small",
    },
    {
      field: "CantidadMaxima",
      header: "Cantidad Máxima",
      headerEn: "Maximum Quantity",
      className: "small",
      summary: "sum",
      Format: "Currency",
    },
    {
      field: "Minimo",
      header: "Cantidad Mínima",
      headerEn: "Minimum amount",
      className: "small",
      Format: "Currency",
      summary: "sum",
    },
    {
      field: "UnitName",
      header: "Unidad Medida",
      headerEn: "Extent",
      className: "small",
    },
    {
      field: "UnitVidaUtilName",
      header: "Medida Vida Util",
      headerEn: "Extent Life Use",
      className: "small",
    },
    {
      field: "VidaUtil",
      header: "Vida Util",
      headerEn: "Useful Life",
      className: "small",
    },
    {
      field: "NombreCategoria",
      header: "Categoría",
      headerEn: "Category",
      className: "small",
    },
    {
      field: "NombreSubcategoria",
      header: "SubCategoría",
      headerEn: "SubCategory",
      className: "medium",
    },
    {
      field: "NombreTipoProducto",
      header: "Tipo",
      headerEn: "Type",
      className: "large",
    },
    {
      field: "NombreBodega",
      header: "Bodega",
      headerEn: "Warehouse ",
      className: "large",
    },
    {
      field: "NombreEstante",
      header: "Estante",
      headerEn: "Shelf",
      className: "Xsmall",
    },
    {
      field: "NombrePosicion",
      header: "Fila",
      headerEn: "Position",
      className: "Xsmall",
    },
    {
      field: "NumeroBandeja",
      header: "Bandeja",
      headerEn: "Tray",
      className: "small",
    },
    {
      field: "FechaUpdate",
      header: "Fecha Creado",
      headerEn: "Date Create",
      Format: "DateTime",
    },
    {
      field: "UserName",
      header: "Usuario Creación",
      headerEn: "User Create",
      className: "small",
      hidden: userAuth.IdRol === 1,
    },

    {
      headerName: "Autorizaciones Compras",
      children: [
        {
          field: "AutorizaGerente",
          header: "Gerente",
          headerEn: "Manager Authorization",
          className: "Xsmall",
          align: "center",
          Format: "Template",
          filter: false,
          body: (rowData) => {
            return rowData.IdProduct ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingTop: "2px",
                }}
              >
                <Checkbox checked={rowData.AutorizaGerente === true} />
              </div>
            ) : null;
          },
        },
        {
          field: "AutorizaBodega",
          header: "Bodega",
          headerEn: "Manager Authorization",
          className: "Xsmall",
          align: "center",
          Format: "Template",
          filter: false,
          body: (rowData) => {
            return rowData.IdProduct ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingTop: "2px",
                }}
              >
                <Checkbox checked={rowData.AutorizaBodega === true} />
              </div>
            ) : null;
          },
        },
      ],
    },
    {
      headerName: "Autorizaciones Bodega",
      children: [
        {
          field: "PermisoSalidaBodegaSolicita",
          header: " Gerente",
          headerEn: "Gerente",
          className: "Xsmall",
          align: "center",
          Format: "Template",
          filter: false,
          body: (rowData) => {
            return rowData.IdProduct ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingTop: "2px",
                }}
              >
                <Checkbox
                  checked={rowData.PermisoSalidaBodegaSolicita === true}
                />
              </div>
            ) : null;
          },
        },
        {
          field: "PermisoSalidaBodegaMASS",
          header: " MASS",
          headerEn: "MASS",
          className: "Xsmall",
          align: "center",
          Format: "Template",
          filter: false,
          body: (rowData) => {
            return rowData.IdProduct ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingTop: "2px",
                }}
              >
                <Checkbox checked={rowData.PermisoSalidaBodegaMASS === true} />
              </div>
            ) : null;
          },
        },
        {
          field: "PermisoSalidaBodegaRRHH",
          header: "RRHH",
          headerEn: "RRHH",
          className: "Xsmall",
          align: "center",
          Format: "Template",
          filter: false,
          body: (rowData) => {
            return rowData.IdProduct ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingTop: "2px",
                }}
              >
                <Checkbox checked={rowData.PermisoSalidaBodegaRRHH === true} />
              </div>
            ) : null;
          },
        },
      ],
    },
    {
      field: "IdProduct",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            if (rowData?.IdProduct) {
              setShowDialog(true);
              setSelected([rowData]);
            }
          },
          tooltipOptions: {
            position: "right",
          },
        },
        {
          icon: "pi pi-eye",
          tooltip: "Img",
          onClick: async (rowData) => {
            if (rowData?.IdProduct) {
              verImagen(rowData);
            }
          },
          tooltipOptions: {
            position: "top",
          },
        },
      ],
    },

    {
      field: "",
      Format: "SplitButton",
      filter: false,
      className: "Xsmall",
      alignFrozen: "right",
      frozen: true,
      Botones: [
        {
          icon: "pi pi-print",
          tooltip: "Etiqueta",
          tooltipOptions: {
            position: "top",
          },
          onClick: (rowData) => {
            if (rowData?.IdProduct) {
              if (selected.length <= 0) {
                setSelected([rowData]);
              }
              if (selected.length > 50) {
                toastShow(
                  toast,
                  "warn",
                  "Advertencia",
                  "Solo se permite seleccionar 50 productos",
                );
              }
              setTimeout(() => {
                setShowEtiqueta(true);
                setEtiquetaQR(true);
              }, 500);
            }
          },
          items: [
            {
              label: "Código QR",
              // icon: "pi pi-qr",
              onClick: (rowData) => {
                if (rowData?.IdProduct) {
                  if (selected.length <= 0) {
                    setSelected([rowData]);
                  }
                  if (selected.length > 50) {
                    toastShow(
                      toast,
                      "warn",
                      "Advertencia",
                      "Solo se permite seleccionar 50 productos",
                    );
                  }
                  setTimeout(() => {
                    setShowEtiqueta(true);
                    setEtiquetaQR(true);
                  }, 500);
                }
              },
            },
            {
              label: "Código de Barras",
              // icon: "pi pi-trash",
              onClick: (rowData) => {
                if (rowData?.IdProduct) {
                  if (selected.length <= 0) {
                    setSelected([rowData]);
                  }
                  if (selected.length > 50) {
                    toastShow(
                      toast,
                      "warn",
                      "Advertencia",
                      "Solo se permite seleccionar 50 productos",
                    );
                  }
                  setTimeout(() => {
                    setShowEtiqueta(true);
                    setEtiquetaQR(false);
                  }, 500);
                }
              },
            },
          ],
        },
      ],
    },
  ];

  const table = {
    Columns: colums,
    Data: productos,
    loading: loading,
    selected: selected,
    showModal: (e) => showModal(e),
    setSelected: (e) => setSelected(e),
  };

  useEffect(() => {
    getInfo();
  }, [IdType]);

  const showModal = () => {};

  const footerContent = (
    <div>
      <Button
        label="Codigo QR"
        className="p-button-text"
        onClick={() => {
          setShowEtiqueta(true);
          setEtiquetaQR(true);
        }}
      />
      <Button
        label="Codigo de Barras"
        className="p-button-text"
        onClick={() => {
          setShowEtiqueta(true);
          setEtiquetaQR(false);
        }}
      />
    </div>
  );

  const getImagenes = async (rowData) => {
    const i = await getListadoImagenes(rowData?.CodigoProducto);
    if (i?.length > 0) {
      let n = await Promise.all(
        i.map(async (e) => {
          try {
            const a = await mostrarImagenesProductos(
              rowData?.CodigoProducto,
              e,
            );
            return a;
          } catch (e) {
            return e;
          }
        }),
      );
      return { CodigoProducto: rowData?.CodigoProducto, img: n };
      // setImagenes({ CodigoProducto: rowData?.CodigoProducto , img: n });
    } else {
      return;
      // setImagenes([]);
    }
  };

  useEffect(() => {
    if (showModalImagenes) {
      getImagenes();
    }
  }, [showModalImagenes]);

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "producto", config.language));
    getInfo();
  }, []);

  return (
    <div
      className=" p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "producto", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              severity="success"
              onClick={() => {
                setShowDialog(true);
                // setSelected([]);
              }}
            />
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />
      {showDialog && (
        <CrudProductoModal
          loading={loading}
          productosDialog={showDialog}
          productos={selected[0] || selected}
          setSelected={setSelected}
          setProductosDialog={setShowDialog}
          getProductos={getInfo}
          modo={selected.length > 0 ? "Editar" : "Crear"}
          setEtiquetaQR={setEtiquetaQR}
          setShowEtiqueta={setShowEtiqueta}
          IdType={IdType}
        />
      )}

      {showDialogCodigo && (
        <Dialog
          header="Imprimir Etiqueta"
          visible={showDialogCodigo}
          style={{ width: "30vw" }}
          onHide={() => setShowDialogCodigo(false)}
          footer={footerContent}
        >
          <p className="m-0">Elija la etiqueta que desea Imprimir</p>
        </Dialog>
      )}

      <Dialog
        header={selectedImg ? selectedImg?.NombreProducto : ""}
        visible={showModalImagenes}
        onHide={cerrarModal}
        className="w-50"
      >
        <div>
          {imagenes?.CodigoProducto && (
            <Carousel
              value={imagenes.img}
              circular
              showIndicators={true}
              itemTemplate={(item) => {
                return (
                  <div
                    className="d-flex"
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      height: "600px",
                    }}
                  >
                    <img
                      src={"data:image/png;base64," + item}
                      alt="imagen"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                );
              }}
            />
          )}
        </div>
      </Dialog>

      {showEtiqueta && (
        <ModalEtiquetaQR
          showEtiqueta={showEtiqueta}
          selected={
            selected.length > 50
              ? selected
                  .slice(0, 50)
                  .sort((a, b) =>
                    a?.NumeroBandeja > b?.NumeroBandeja ? 1 : -1,
                  )
              : selected
          }
          setShowEtiqueta={setShowEtiqueta}
          getInfo={getInfo}
          setSelected={setSelected}
          etiquetaQR={etiquetaQR}
        />
      )}
    </div>
  );
};

export default ProductosScreen;
